import React, { FunctionComponent, useMemo } from "react";
import {
  BenchmarkStatus,
  ColorCriteria,
  EvidenceColumn,
  MeasurementType,
} from "../../../../../../store/onboarding/types";
import ColorColorCriteriaRow from "./ColorColorCriteriaRow";
import Table from "react-bootstrap/Table";
import { getStudentsNum } from "./helpers";
import { Grade } from "../../../../../../store/groups/types";
import { all } from "axios";

type Props = {
  measurementType?: MeasurementType;
  allColorCriteria: any[];
  evidenceColumnStdScore?: any[];
  selectedGrade?: Grade;
  withoutStats?: boolean;
};

const MAX_DISPLAYED_VALUE = 1999;

const ColorCriteriaTable: FunctionComponent<Props> = (props) => {
  const {
    measurementType,
    allColorCriteria,
    evidenceColumnStdScore,
    selectedGrade,
    withoutStats,
  } = props;

  const getStudentsNumByColorCriteria = evidenceColumnStdScore?.length
    ? (colorCriteria: ColorCriteria) =>
        getStudentsNum(evidenceColumnStdScore,colorCriteria, measurementType, selectedGrade)
    : null;

  const totalStudents = useMemo(() => {
    if (!getStudentsNumByColorCriteria) {
      return null;
    }

    return allColorCriteria.reduce<number>(
      (pV, cV) => pV + getStudentsNumByColorCriteria(cV),
      0
    );
  }, [allColorCriteria]);

  const studentDistribution = useMemo(() => {
    if(allColorCriteria.length) {
      let studentRange = allColorCriteria.reduce((acc: any, colorCriteria: ColorCriteria) => {
        if(colorCriteria != null) {
          const studentsNum = getStudentsNumByColorCriteria
            ? getStudentsNumByColorCriteria(colorCriteria)
            : 0;
          let displayRange = `${colorCriteria?.range_min} - ${colorCriteria?.range_max}`;
          if (colorCriteria.range_max! > MAX_DISPLAYED_VALUE) {
            displayRange = `${colorCriteria.range_min}+`;
          }  
          acc[displayRange] = {
            studentCount: studentsNum,
            percentage: totalStudents
              ? Math.round((studentsNum / totalStudents) * 100)
              : 0,
          };
        }
        return acc;
      }, {});
      return studentRange;
    } else {
      return null;
    }

  }, [allColorCriteria]);


  // let isCustomColorExist = false;
  // allColorCriteria.map((ac) => {
  //   if (ac?.user_id) {
  //     isCustomColorExist = true;
  //     return;
  //   }
  // });
  
  return (
    <Table className="viewBenchmarksTable mb-0">
      <thead>
        <tr>
          <th>Level</th>
          {measurementType !== MeasurementType.CATEGORY && <th>Score Range</th>}
          {!withoutStats && (
            <>
              <th>Students</th>
              <th>Students (%)</th>
            </>
          )}
        </tr>
      </thead>
      <tbody>
        {allColorCriteria.length > 0 ? (
          allColorCriteria.map((colorCriteria: ColorCriteria, index) => (
            <ColorColorCriteriaRow
              key={index}
              measureType={measurementType}
              colorCriteria={colorCriteria}
              totalStudents={totalStudents}
              getStudentsNumByColorCriteria={getStudentsNumByColorCriteria}
              withoutStats={withoutStats}
              studentDistribution={studentDistribution}
            />
            // <> //old code for hiding default colors if custom colors exist
            //   {isCustomColorExist && colorCriteria?.user_id && (
            //     <ColorColorCriteriaRow
            //       key={index}
            //       measureType={measurementType}
            //       colorCriteria={colorCriteria}
            //       totalStudents={totalStudents}
            //       getStudentsNumByColorCriteria={getStudentsNumByColorCriteria}
            //       withoutStats={withoutStats}
            //       studentDistribution={studentDistribution}
            //     />
            //   )}
            //   {!isCustomColorExist && !colorCriteria?.user_id && (
            //     <ColorColorCriteriaRow
            //       key={index}
            //       measureType={measurementType}
            //       colorCriteria={colorCriteria}
            //       totalStudents={totalStudents}
            //       getStudentsNumByColorCriteria={getStudentsNumByColorCriteria}
            //       withoutStats={withoutStats}
            //       studentDistribution={studentDistribution}
            //     />
            //   )}
            // </>
          ))
        ) : (
          <tr>
            <td colSpan={withoutStats ? 2 : 4}>No Data Available</td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

export default ColorCriteriaTable;
